<site-header></site-header>

<ion-content>
  <ion-row class="ion-align-items-center ion-justify-content-center">
    <ion-col sizeLg="10" class="inside-col">
      <div class="holder">
        <ion-row>
          <ion-col sizeLg="6">
            <div class="card">
              <div class="profile-img-holder flex-center fd">
                <ion-avatar>
                  <img
                    src="https://res.cloudinary.com/mangoit/image/upload/v1593469647/profile_photo_Longchi_w53gyd.jpg"
                    alt="Longchi Kanouo"
                  />
                </ion-avatar>
                <h2>
                  Longchi Kanouo &nbsp;
                  <a
                    href="https://www.linkedin.com/in/longchikanouo/"
                    target="_blank"
                    ><ion-icon color="tertiary" name="logo-linkedin"></ion-icon
                  ></a>
                </h2>
                <p>
                  <ion-icon color="" name="mail-outline"></ion-icon>
                  glongchi@koomzo.com
                </p>
              </div>

              <div class="description ion-text-center">
                <p
                  class="ion-text-wrap ion-text-start"
                  style="color: --ion-color-medium;"
                >
                  Longchi is a seasoned Software Engineer/Architect with over 12
                  years industry experience, spanning government, telecom,
                  finance, transport and healthcare sectors in both UK , China,
                  Africa and US. <br />
                  He specializes in enterprise scale applications for the Web
                  and Mobile.
                </p>
              </div>
            </div>
          </ion-col>
          <ion-col sizeLg="6">
            <div class="card">
              <div class="profile-img-holder flex-center fd">
                <ion-avatar>
                  <img
                    src="https://res.cloudinary.com/mangoit/image/upload/v1593469647/profile_photo_basile_bv9tfh.jpg"
                    alt="Basile Njei, MD, MPH"
                  />
                </ion-avatar>
                <h2>
                  Basile Njei, MD, MPH &nbsp;
                  <a
                    href="https://www.linkedin.com/in/basile-njei-md-mph-16170330/"
                    target="_blank"
                    ><ion-icon color="tertiary" name="logo-linkedin"></ion-icon
                  ></a>
                </h2>
                <!-- <p>
                  <ion-icon color="" name="mail-outline"></ion-icon>
                  glongchi@koomzo.com
                </p> -->
              </div>

              <div class="description ion-text-center">
                <p
                  class="ion-text-wrap ion-text-start"
                  style="color: --ion-color-medium;"
                >
                  Assistant Professor Adjunct at Yale University School of
                  Medicine Message
                </p>
              </div>
            </div>
          </ion-col>

          <!-- <ion-col sizeLg="6">
            <div class="card">
              <div class="profile-img-holder flex-center fd">
                <ion-avatar>
                  <img src="assets/imgs/profile.jpg" alt="" />
                </ion-avatar>
                <h2>John Doe</h2>
                <p>abc@def.com</p>
              </div>

              <div class="description ion-text-center">
                <p class="ion-text-wrap">
                  Lorem ipsum dolor sit amet, consectetur .
                </p>
              </div>
            </div>
          </ion-col> -->
        </ion-row>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
